import { Card } from "../../../components/ui/card";
import { Upload, Link2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const RcmLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen flex items-center justify-center p-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[1100px]">
        <Card
          className="p-6 hover:shadow-lg transition-shadow cursor-pointer flex flex-col"
          onClick={() => navigate("/audit/create-control/upload")}
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
              <Upload className="h-6 w-6 text-orange-600" />
            </div>
            <h2 className="text-lg font-semibold">Import from Excel or CSV</h2>
          </div>
          <p className="text-sm text-stone-600 mb-6 flex-grow">
            Upload your existing Risk & Control Matrix and let Midship
            automatically parse, structure, and organize your controls into a
            hierarchical framework.
          </p>
          <div className="text-sm text-orange-600 font-medium mt-auto">
            Import RCM
          </div>
        </Card>

        <Card
          className="p-6 hover:shadow-lg transition-shadow cursor-pointer flex flex-col"
          onClick={() => navigate("/audit/controls/v2/create/manual")}
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
              <Link2 className="h-6 w-6 text-blue-600" />
            </div>
            <h2 className="text-lg font-semibold">Create Controls Manually</h2>
          </div>
          <p className="text-sm text-stone-600 mb-6 flex-grow">
            Build your control framework from scratch with a guided form.
            Perfect for new controls or when you need precise control over each
            data field.
          </p>
          <div className="text-sm text-blue-600 font-medium mt-auto">
            Create Control
          </div>
        </Card>
      </div>
    </div>
  );
};

export default RcmLandingPage;
